import React, { useState } from "react";
import { Input, Modal } from "antd";

import { type SupportRequestStatus } from "@fitness-app/data-models";

import { STATUS_LABELS } from "../supportConstants";

export interface PendingStatusChange {
  requestId: string;
  displayId: number;
  status: SupportRequestStatus;
}

interface StatusChangeCommentModalProps {
  pending: PendingStatusChange | null;
  onCancel: () => void;
  onSubmit: (comment?: string) => void;
}

// Closing/rejecting a request asks for an optional note (TRE-1765 #4) — saved as a
// comment linked to the transition and mirrored to the request's Slack thread.
// Cancel aborts the status change entirely.
export const StatusChangeCommentModal: React.FC<StatusChangeCommentModalProps> = ({ pending, onCancel, onSubmit }) => {
  const [comment, setComment] = useState("");

  return (
    <Modal
      open={Boolean(pending)}
      title={pending ? `Zgłoszenie #${pending.displayId} → ${STATUS_LABELS[pending.status]}` : ""}
      okText="Zmień status"
      cancelText="Anuluj"
      onCancel={onCancel}
      onOk={() => onSubmit(comment.trim() || undefined)}
      afterClose={() => setComment("")}
    >
      <Input.TextArea
        autoFocus
        autoSize={{ minRows: 3, maxRows: 8 }}
        value={comment}
        onChange={(event) => setComment(event.target.value)}
        placeholder="Co się stało? Komentarz trafi do zgłoszenia i do wątku na Slacku (opcjonalnie)"
      />
    </Modal>
  );
};
